<template>
  <div>
    <div class="bg-white p-5 shadow m-2 rounded-md">
      <section class="text-lg font-semibold mb-5">
        Role: {{ showRoles(userDetails && userDetails.role) }}
      </section>
      <!-- email update section start -->
      <section class="relative">
        <spinner :loading="userEmailLoader" />
        <div>
          <div class="text-xl text-gray-800 inline-block mr-2">Email</div>
          <input
            type="email"
            placeholder="Email"
            class="input input-bordered w-full md:w-1/2 mb-2 mt-2"
            name="userEmail"
            v-model="userEmail"
          />
        </div>
        <button
          @click="updateUserEmail"
          type="submit"
          class="btn btn-primary text-lg ml-3 mt-2"
        >
          Update
        </button>
      </section>
      <!-- email update section end -->
      <!-- create new segment from engaged users start -->
      <section class="relative mt-10 flex items-center">
        <spinner :loading="updateSegmentLoader" />
        <div class="text-xl text-gray-800 inline-block">
          Update Segments from
        </div>
        <button
          @click="updateSegmenFromEngagement"
          type="submit"
          class="btn btn-primary text-lg ml-3 mt-3 max-w-md"
        >
          Engagement
        </button>
      </section>
      <!-- create new segment from engaged users end -->
      <!-- choose either you want to show button below or above  -->
      <section class="relative mt-10 flex items-center">
        <spinner :loading="updateSegmentLoader" />
        <div class="text-xl text-gray-800 inline-block mr-3">
          Show connect tab button below
        </div>
        <input type="checkbox" class="toggle toggle-accent" v-model="isAbove" />
      </section>

      <section class="relative mt-12 flex items-center">
        <spinner :loading="updateSegmentLoader" />
        <div class="text-xl text-gray-800 inline-block mr-3">Refresh DMs</div>
        <div
          :class="['cursor-pointer', dmLoading && 'animate-spin']"
          @click="!dmLoading ? updateDMList() : ()=>{}"
        >
          <refresh width="20px" height="20px" />
        </div>
      </section>

      <section class="relative mt-12 flex items-center">
        <spinner :loading="updateSegmentLoader" />
        <div class="text-xl text-gray-800 inline-block mr-3">
          Refresh Engagement
        </div>
        <div
          :class="['cursor-pointer', engagmentLoading && 'animate-spin']"
          @click="!engagmentLoading ? getMyMentions() : ()=>{}"
        >
          <refresh width="20px" height="20px" />
        </div>
      </section>

      <section class="relative mt-12 flex items-center">
        <!-- <spinner :loading="updateSegmentLoader" /> -->
        <div class="text-xl text-gray-800 inline-block mr-3">
           Clear All Dms in Queue
        </div>
         <font-awesome-icon
         @click="handleClearDmsQueue"
          class="reaction text-gray-600 cursor-pointer"
          size="lg"
          :icon="['far', 'trash-alt']"
          />
      </section>

            <section class="relative mt-12 flex items-center">
        <!-- <spinner :loading="updateSegmentLoader" /> -->
        <div class="text-xl text-gray-800 inline-block mr-3">
           Clear All Reply in Queue
        </div>
         <font-awesome-icon
         @click="handleClearReplyQueue"
          class="reaction text-gray-600 cursor-pointer"
          size="lg"
          :icon="['far', 'trash-alt']"
          />
      </section>

    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';
import spinner from '@/components/spinner.vue';
import userRoles from '@/utils/Constants/userRoles';
import Refresh from '../icons/refresh.vue';
import userInfo from '@/services/userInfo';

export default {
  components: { spinner, Refresh },
  name: 'Account',
  data() {
    return {
      userEmail: '',
      userEmailLoader: false,
      updateSegmentLoader: false,
      isAbove: false,
      callingNumber: 0,
      dmLoading: false,
      engagmentLoading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userDetails() {
      return this.$store.state?.userDetails;
    },
    // isAbove() {
    //   return !this.$store.state?.userDetails?.configureInfo?.connectTabBtnShowAbove;
    // },
  },
  async mounted() {
    if (!this.userDetails) {
      await this.$store.dispatch('getMyDetails', {});
    }
    console.log(this.userDetails, 'userDetails');
    this.userEmail = this.userDetails?.userEmail;
    this.isAbove = !this.userDetails?.configureInfo?.connectTabBtnShowAbove;
  },
  watch: {
    async user(val) {
      await this.$store.dispatch('getMyDetails', {});
      this.userDetails = this.$store.state?.userDetails;
      this.userEmail = this.userDetails?.userEmail;
      return val;
    },
    isAbove(newVal) {
      this.buttonsPosition(newVal);
    },
    userDetails(newVal) {
      this.isAbove = !newVal?.configureInfo?.connectTabBtnShowAbove;
    },
  },
  methods: {
    async updateUserEmail() {
      try {
        this.userEmailLoader = true;
        await this.$store.dispatch('updateEmail', {
          userEmail: this.userEmail,
        });
        this.userEmailLoader = false;
        utils.setStatusMsg(this, 'email updated successfully');
      } catch (error) {
        this.userEmailLoader = false;
        console.log(error?.response?.data?.message || 'something went wrong');
        utils.setStatusMsg(
          this,
          error?.response?.data?.message || 'something went wrong',
        );
      }
    },
    async updateSegmenFromEngagement() {
      try {
        this.updateSegmentLoader = true;
        this.$store.dispatch('updateSegmentFromEngagement');
        this.updateSegmentLoader = false;
        utils.setStatusMsg(this, 'updated successfully');
      } catch (error) {
        this.updateSegmentLoader = false;
        console.log(error?.response?.data?.message || 'something went wrong');
        utils.setStatusMsg(
          this,
          error?.response?.data?.message || 'something went wrong',
        );
      }
    },
    showRoles(role = 'SUPERADMIN') {
      switch (role) {
        case userRoles.USER:
          return 'FREE';
        case userRoles.COURSE_CREATOR:
          return 'PRO';
        case userRoles.CREATOR:
          return 'CREATOR';
        case userRoles.BUSINESS:
          return 'BUSINESS';
        case userRoles.MEMBER:
          return 'MEMBER';
        case userRoles.SUPERADMIN:
          return 'ADMIN';
        default:
          return 'FREE';
      }
    },
    async buttonsPosition(newVal) {
      // if (this.callingNumber || this.isAbove === true) {
      try {
        const response = await this.$store.dispatch('changeButtonPossition', {
          isAbove: !newVal,
        });
        utils.setStatusMsg(this, response?.message);
      } catch (error) {
        console.log(error, 'error');
        utils.setStatusMsg(
          this,
          error?.response?.data?.message || 'something went wrong',
        );
      }
      // }
      // this.callingNumber = 1;
    },
    async updateDMList() {
      try {
        this.dmLoading = true;
        const dmRes = await this.$store.dispatch('updateDmList');
        console.log({ dmRes });
        this.dmLoading = false;
        utils.setStatusMsg(this, dmRes?.data?.message);
      } catch (error) {
        this.dmLoading = false;
        console.log('get dm list error ', error);
        utils.setStatusMsg(this, error?.response?.data?.message);
      }
    },
    async getMyMentions() {
      try {
        this.engagmentLoading = true;
        const replyRes = await userInfo.getAllMentions();
        console.log({ replyRes });
        this.engagmentLoading = false;
        utils.setStatusMsg(this, replyRes?.message);
      } catch (error) {
        this.engagmentLoading = false;
        console.log('get last reply error ', error);
        utils.setStatusMsg(this, error?.response?.data?.message);
      }
    },
    async handleClearDmsQueue() {
      try {
        this.$store.commit('toggleLoading', true);
        const response = await this.$store.dispatch('handleClearDmsQueue');
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, response?.message);
      } catch (error) {
        console.log('handle delete dms queue', error);
        utils.setStatusMsg(this, error?.response?.data?.message || 'something went wrong');
        this.$store.commit('toggleLoading', false);
      }
    },
    async handleClearReplyQueue() {
      try {
        this.$store.commit('toggleLoading', true);
        const response = await this.$store.dispatch('handleClearReplyQueue');
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, response?.message);
      } catch (error) {
        console.log('handle delete dms queue', error);
        utils.setStatusMsg(this, error?.response?.data?.message || 'something went wrong');
        this.$store.commit('toggleLoading', false);
      }
    },
  },
};
</script>
